module.exports = __webpack_public_path__ + "static/media/branded-order-card-not-saved-logo.18ae3392.svg";